import React, { useState, useRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { addLocale } from 'primereact/api'
import Base64Downloader from 'common-base64-downloader-react';
import apis from '../../api';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { DataScroller } from 'primereact/datascroller';
import './DataScrollerDemo.css';
import { Label, LabelField } from './Pila.styles';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import Video from '../Video/Video';
import useWindowDimensions from '../hooks/useDimensions';
import './Pila.css'
import ConfBar from '../ConfBar/ConfBar';
import { saveAs } from 'file-saver';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Pila
Description : Planillas de PILA.
Date Autor Modification
================================================================================
04/01/2024 Santiago Coca Rojas Creación 
================================================================================ */

export default function Pila(props) {

    // declaración de constantes
    const [contenido, setContenido] = useState("")
    const [generado, setGenerado] = useState(false)
    const toast = useRef(null);
    const [isOpen, setIsOpen] = React.useState(false);
    const [isOpenCorreo, setIsOpenCorreo] = React.useState(false);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const [rowStateFile, setRowStateFile] = useState({});
    const [rowStateMail, setRowStateMail] = useState({});
    const [correo, setCorreo] = useState(localStorage.getItem('user') ? localStorage.getItem('user') : "")
    const [voucher, setVoucher] = useState({
        CLIENT: localStorage.getItem('client'),
        ENTITY: localStorage.getItem('entity'),
        NUMBER_ID: '',
        YEAR: '',
        MONTH: '',
    });
    const { width } = useWindowDimensions()
    const elementWidth = { width: width > 640 ? "60% " : "80%" };
    const headers = { authorization: localStorage.getItem('token') }
    const [listVoucher, setListVoucher] = useState([]);
    const [idMail, setIdMail] = useState("")
    const [voucherIdMail, setVoucherIdMail] = useState("")

    /*Propiedades de la tabla del componente*/
    const [rowData, setRowData] = useState([]);
    const [rows, setRows] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(10);
    const [selectedRows, setSelectedRows] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    // Nombre de lista de comprobantes
    useEffect(() => {
        let name = [{ name: 'Plantilla PILA' }]
        setListVoucher(name);
    }, []);

    useEffect(() => {
        let payload = {
            CLIENT: localStorage.getItem('client'),
            ENTITY: localStorage.getItem('entity')
        }
        try {
            setTabla(payload)
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, life: 4000 })
        }
    }, [])

    // Idioma del componente Calendar
    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    /*Funciones que manejan el comportamiento de la tabla del componente*/
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    const template2 = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 20, value: 20 }
            ];

            return (
                <React.Fragment>
                    <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por página: </span>
                    <Dropdown className="sel" value={options.value} options={dropdownOptions} onChange={options.onChange} />
                </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                    {options.first} - {options.last} of {options.totalRecords}
                </span>
            )
        }
    };

    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button style={{ marginLeft: "-36rem" }} type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText className="p-inputtext-sm" value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" />
                </IconField>
            </div>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div>
                <Button icon="pi pi-file-pdf" loading={rowStateFile[rowData.rowId]} className="p-button-danger mr-2 p-button-sm text-xs" tooltip="Comprobante" tooltipOptions={{ position: 'top' }}
                    onClick={() => {
                        setRowStateFile({ ...rowStateFile, [rowData.rowId]: true });
                        generateVoucher(rowData.rowId, rowData.ID);
                    }} />
            </div>
        )
    }

    const onGlobalFilterChange1 = (e) => {
        /*Filtro global de la tabla*/
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;

        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    const clearFilter1 = () => {
        initFilters1();
    }

    const initFilters1 = () => {
        /*Filtros de la tabla del componente*/
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'CONTRACT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'CALENDAR': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'CONCEPT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NAME_CONCEPT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'TYPE_CONCEPT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'BASE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'REMUNER': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'REMUNER_CSO': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'UNITY': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'UND_CSO': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        });
        setGlobalFilterValue1('');
    }

    const header1 = renderHeader1();

    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];

    // mostrar modal
    const showModal = () => {
        setIsOpen(true);
    };

    // ocultar modal
    const hideModal = () => {
        setIsOpen(false);
    };

    const showModalCorreo = () => {
        setIsOpenCorreo(true);
    };

    // ocultar modal
    const hideModalCorreo = () => {
        setIsOpenCorreo(false);
    };

    async function setTabla(payload) {

        try {
            await apis.getPila(payload, headers).then(res => {
                let data = res.data.PILA;
                let rowData = [];
                let statesFile = {}
                let statesMail = {}
                let rowCounter = 0;
                data.forEach(element => {
                    let e = {
                        rowId: rowCounter,
                        ...element,
                    }
                    statesFile = {
                        ...statesFile,
                        [rowCounter]: false
                    }
                    statesMail = {
                        ...statesMail,
                        [rowCounter]: false
                    }
                    rowCounter++;
                    rowData.push(e)
                })
                setRows(rowData)
                setRowStateFile(statesFile)
                setRowStateMail(statesMail)
                setLoading1(false)
                // setLoadPage(true)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Consulta exitosa', life: 4000 })
            })
        }
        catch (err) {
            setLoading1(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, life: 4000 })
        }
    }

    // generar reporte
    async function generateVoucher(id, voucherId) {

        const { CLIENT, ENTITY } = voucher

        let report = {
            CLIENT,
            ENTITY,
            KEY: voucherId
        }
        try {
            await apis.postPila(report, headers).then(res => {
                let file_name = res.data.NAME
                let data = res.data.DETAIL
                let text = data;
                let contenido = "";
                text.forEach(res => {
                    contenido += res.LINE + '\r\n';
                })
                const blob = new Blob([contenido], { type: 'text/plain;charset=utf-8' });
                saveAs(blob, file_name);
                setGenerado(true);
                setRowStateFile({ ...rowStateFile, [id]: false });
                setRowStateMail({ ...rowStateMail, [id]: false });
                // showModal()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Archivo generado éxitosamente", life: 4000 })
            })
        }
        catch (err) {
            setRowStateFile({ ...rowStateFile, [id]: false });
            setRowStateMail({ ...rowStateMail, [id]: false });
            setLoading3(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, life: 4000 })
        }
    }

    const sendMailVoucher = async (id, voucherId) => {
        setLoading3(true)
        const mail = correo
        generateVoucher(id, voucherId, mail, "SI")
    }

    const isMail = async (id, voucherId) => {
        if (localStorage.getItem("type") === "ADMIN") {
            setIdMail(id)
            setVoucherIdMail(voucherId)
            showModalCorreo()
        }
        else {
            sendMailVoucher(id, voucherId)
        }
    }

    // Cuerpo modal lista de comprobantes
    const itemTemplate = (data) => {
        return (
            <div className="product-item">
                {/* <img src="https://remunerwallet.s3.us-east-2.amazonaws.com/61/firma/unnamed.png" style={{ width: "50px" }} onError={(e) => e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} alt={data.name} /> */}
                <div className="product-detail">
                    <div className="product-name text-lg">{data.name}</div>
                    <div className="product-description">{data.description}</div>
                </div>
                <div className="product-action">
                    <Base64Downloader style={{ border: "0px", background: "transparent" }} base64={contenido} downloadName="comprobante" onDownloadSuccess={() => { setLoading2(false); hideModal() }}>
                        <Button icon="pi pi-arrow-down" loading={loading2} onClick={() => setLoading2(true)} />
                    </Base64Downloader>

                </div>
            </div>
        );
    }

    // Configuración para parametros variables tipo select
    function handleChange(value, label) {
        console.log(value, label)
        setVoucher({
            ...voucher,
            [label]: value
        })
    }

    const mailFooter = (
        <Button label='Enviar' loading={loading3} onClick={() => sendMailVoucher(idMail, voucherIdMail)} />
    )

    // Return que entrega la pantalla
    return (
        <div className='mt-2 flex justify-content-center align-items-center'>
            <Toast ref={toast} />

            <Dialog visible={isOpen}
                position="top" style={{ width: "36rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
                <div className="datascroller-demo">
                    <div className="card">
                        <DataScroller value={listVoucher} itemTemplate={itemTemplate} rows={5} inline scrollHeight="500px" header="Descarga el documento" />
                    </div>
                </div>
            </Dialog>

            <Dialog visible={isOpenCorreo} header="Enviar por correo" footer={mailFooter}
                position="top" style={{ width: "36rem" }} draggable={false} resizable={false} modal onHide={hideModalCorreo}>
                <Label htmlFor="label">Correo*</Label>
                <InputText type='email' value={correo} onChange={(e) => setCorreo(e.target.value)} />
            </Dialog>

            <div class="surface-100	 px-4 py-5 md:px-6 lg:px-8">
                <div class="grid">
                    <div class="col-12 ">
                        <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-1">
                            <span className="text-900">Planillas PILA</span>
                        </div>
                        <div className="mt-6">
                            <ConfBar />
                        </div>
                    </div>
                    <div 
                        className='card'
                        style={{
                        marginTop: '2rem',
                        width: '100%',
                    }}>
                        <DataTable className="text-xs" value={rows} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                            selection={selectedRows} onSelectionChange={(e) => setSelectedRows(e.value)} dataKey="ID"
                            size="small">
                            <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
                            <Column field="DESCRIPTION" headerStyle={{ width: '12rem', textAlign: 'center' }} header="Descripción"></Column>
                            <Column header="Documento" headerStyle={{ width: '12rem', textAlign: 'center' }} body={actionBodyTemplate}></Column>
                        </DataTable>
                    </div>
                </div>
            </div>
        </div>
    );
}